import { buildQueryString } from '../../commons/grid/buildQueryString.js';

/** Los filtros, con el mismo nombre de clave que espera GET /equipamiento/newGrid. */
export const CAMPOS_DE_FILTRO = ['identificador', 'tipo', 'marca', 'modelo', 'vehiculo'];

/**
 * Las columnas ordenables. Viajan como `<campo>Sort`. `activo` es el orden inicial (inactivos primero, como la
 * grilla anterior) y no tiene encabezado clickeable.
 */
export const CAMPOS_DE_ORDEN = ['activo', 'identificador', 'tipo', 'marca', 'modelo', 'vehiculo'];

const paramsDe = (campos, valores, sufijo) => {
	const params = {};
	const origen = valores || {};
	campos.forEach((campo) => {
		params[campo + (sufijo || '')] = origen[campo];
	});
	return params;
};

/** La grilla pagina desde 0 y el backend desde 1. */
export const buildEquipamientoQuery = (pagination, filterQuery, sortQuery) =>
	buildQueryString(Object.assign(
		{ page: ((pagination || {}).page || 0) + 1, perPage: (pagination || {}).perPage },
		paramsDe(CAMPOS_DE_FILTRO, filterQuery),
		paramsDe(CAMPOS_DE_ORDEN, sortQuery, 'Sort')
	));

export default buildEquipamientoQuery;
